export const COVER_SETTINGS_TOGGLE_OTHER_INFOS =
  'REPORTING_COVER_SETTINGS_TOGGLE_OTHER_INFOS';

export const toggleOtherInfos = id => ({
  type: COVER_SETTINGS_TOGGLE_OTHER_INFOS,
  id,
});
